import React from 'react';
import MuiContainer from '@material-ui/core/Container';
import PropTypes from 'prop-types';

const BaseContainer = MuiContainer;

BaseContainer.propTypes = {
  component: PropTypes.elementType,
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
};

const Container = (props) => {
  return (
    <BaseContainer {...props}>
      {props.children}
    </BaseContainer>
  )
};

// const Container = BaseContainer;

export default Container;
